// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__2MtYl","savePackageButton":"ClientWallet_savePackageButton__2-mTH"};